import useSWR from 'swr';
import httpApi from './api/httpApi';

const COUNTRIES_URL = '/api/v1/countries';

const useCountriesSWR = () => {
    const fetchUser = (query): Promise<COUNTRIES> => {
        return httpApi
            .get<{ countries: COUNTRIES }>(query)
            .then((res) => {
                return res.getData().countries;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        COUNTRIES_URL,
        fetchUser,
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    const convertData = (data) => {
        return Object.keys(data);
    };

    return {
        countries: data ? convertData(data) : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useCountriesSWR;

type COUNTRIES = {
    countries: object;
};
